import React, {Component} from 'react'
import EditNicknameField from './EditNicknameField'
import { STATUS } from '../../../Templates/data'
import { connect } from "react-redux";
import {editDeviceNickname, editDeviceType} from "../../../../redux/actions/management_actions"
import { setDeviceAuthorization } from "../../../../redux/actions/management_actions"
import AuthorizationDropDown from './AuthorizationDropDown'
import TypeDropDown from './TypeDropDown'
class DeviceSummary extends Component {

    state = {
        editingDeviceName: false,
        editingDeviceIcon: false,
        editingDeviceAuthorization: false
    }

    renderButton = (activityStatus) => {
        return <div id="device-status" className="flex">
            <p id="sync-status-text" style={{ backgroundColor: STATUS[`${activityStatus}`] }}>
                {`${activityStatus}`}</p>
        </div>
    }

    renameDevice = (nickname) => {
        if (nickname) {
            let currentNickname = this.props.device.nickname
            if (currentNickname !== nickname) {
                this.props.editDeviceNickname(this.props.device._id, nickname)
                this.setState({
                    nickname,
                    editingDeviceName: false
                })
            } else {
                this.setState({
                    editingDeviceName: false
                })
            }
        } else {
            this.props.editDeviceNickname(this.props.device._id, this.props.device.name)
            this.setState({
                nickname: "",
                editingDeviceName: false
            })
        }
    }
setDeviceAuthorization = (value) => {
    this.props.updateDeviceAuthorization(value)
    this.props.setDeviceAuthorization(this.props.device._id, value)
}

    setType = (newType) => {
        let type = this.props.device.type
        if (type !== newType) {
            this.props.editDeviceType(this.props.device._id, newType)
            this.setState({
                type: newType,
                editingDeviceIcon: false
            })
        } else {
            this.setState({
                editingDeviceIcon: false
            })
        }
    }
    toggleMenu = () => {
        this.setState(prevState => ({ editingDeviceIcon: !prevState.editingDeviceIcon }))
    }

    render() {
        const {date, activityStatus, name, nickname, type} = this.props.device
        let ymd = date ? date.split("T")[0] : 0
        let time = date ? date.split("T")[1].slice(0, 5) : 0
        return <div id="device-summary-container" className="flex-column shadow">
                    <div id="device-summary-header">
                        <h3 className="break-word">{nickname}</h3>
                    </div>
                    <div id="device-summary-info" className="flex-column">
                        <div>Registration Date: {`${ymd} at ${time}`}</div>
                        <div className="flex">Activity Status: {activityStatus} {this.props.renderActivityIcon(activityStatus)}</div>
                        <div>Unique ID: {name}</div>
        
                            <div className="flex" style={{alignItems: "flex-end"}}>
                                <header style={{ marginRight: '.25em'}}>Device Nickname: </header>
                                <EditNicknameField renameDevice={this.renameDevice} nickname={nickname} />
                            </div>
                        <div className="flex" style={{alignItems: 'flex-end'}}>
                            <div style={{ marginRight: '.25em' }} >Device Type: </div>
                            <TypeDropDown
                                options={["Tablet", "Laptop", "Mobile", "Desktop", "VR", "Unknown"]}
                                selection={type}
                                selectOption={(value) => this.setType(value)}
                            />
                        </div>
                        <div className="flex" style={{alignItems: "flex-end"}}> 
                            <p>Authorization Status: </p>
                            <AuthorizationDropDown 
                                options={["Authorize Access", "Deny Access"]}
                                selection={this.props.device.authorized}
                                selectOption={(value) => this.setDeviceAuthorization(value)}    
                            />
                        </div>
                                {/* <div className="flex-centered">
                                    <div id="device-management-button" className="management-button" style={{width: "50%", marginTop: "1em"}}>
                                        Save Device Changes
                                    </div>
                                </div> */}
                </div>
            </div>
    }
}

const mapDispatchToProps = (dispatch) => {
    return ({
        editDeviceNickname: (id, nickname) => dispatch(editDeviceNickname(id, nickname)),
        editDeviceType: (id, type) => dispatch(editDeviceType(id, type)),
        setDeviceAuthorization: (id, authorization) => dispatch(setDeviceAuthorization(id, authorization)),
    });
}

export default connect(null, mapDispatchToProps)(DeviceSummary);